import React from 'react';
import { EntityContext, EntityContextType } from 'nekst-api';
import styles from '../ChatWidget.module.scss';

interface ContextChipProps {
  context: EntityContext;
  onRemove?: () => void;
}

function getTypeLabel(type: EntityContextType): string {
  switch (type) {
    case 'transaction':
      return 'Transaction';
    case 'task':
      return 'Task';
    case 'contact':
      return 'Contact';
    case 'team_member':
      return 'Team Member';
    default:
      return type;
  }
}

export default function ContextChip(props: ContextChipProps) {
  const { context, onRemove } = props;

  return (
    <span className={styles.contextChip}>
      <span className={styles.contextChipType}>{getTypeLabel(context.type)}</span>
      <span className={styles.contextChipId}>#{context.id}</span>
      {onRemove && (
        <button
          type="button"
          className={styles.contextChipRemove}
          onClick={onRemove}
          aria-label="Remove context"
        >
          ×
        </button>
      )}
    </span>
  );
}
